import api from "../api/api";
import { AccountStatus } from "../enums/account-status.enum";
import { QueryAction } from "../enums/action.enum";
import { ApiTypeEnum } from "../enums/api-type.enum";
import { UserStatus } from "../enums/user-status.enum";
import { PASSWORDRESETMUTATION } from "../graphql/mutations/passwordreset.mutation";
import { USERMUTATION } from "../graphql/mutations/user.mutation";
import { LOGINUSERQUERY } from "../graphql/queries/login-user.query";
import { USERQUERY } from "../graphql/queries/user.query";

export const loginUserService = (data) => {
  return api.call({
    data,
    query: LOGINUSERQUERY,
    action: QueryAction.GET,
  });
};

export const getUserService = (data) => {
  return api.call({
    requiresToken: true,
    data,
    query: USERQUERY,
    action: QueryAction.GET,
  });
};

export const createUserService = (data) => {
  return api.call({
    type: ApiTypeEnum.User,
    data: {
      customer: {
        customerType: "PUBLIC",
      },

      username: data.username,
      password: data.password,
      status: UserStatus.New,
      accounts: [
        {
          accountName: data.username,
          status: AccountStatus.InReview,
          marketingAllowed: data.isMktSelected,
          referee: {
            code: data.referralCode,
          },
        },
      ],
    },
    action: QueryAction.CREATE_USER,
    query: USERMUTATION,
  });
};

export const enterOtpService = (data) => {
  return api.call({
    type: ApiTypeEnum.User,
    data: {
      ...data,
    },
    query: USERMUTATION,
    action: QueryAction.VERIFY_USER,
  });
};

export const updateUserService = ({
  userDetails,
  action = QueryAction.UPDATE_USER,
  requiresToken = false,
}) => {
  return api.call({
    type: ApiTypeEnum.User,
    requiresToken,
    data: {
      ...userDetails,
    },
    query: USERMUTATION,
    action,
  });
};

export const updateNewPasswordService = (userDetails) => {
  return api.call({
    type: ApiTypeEnum.User,
    data: {
      ...userDetails,
    },
    query: USERMUTATION,
    action: QueryAction.PASSWORD_RESET,
  });
};

export const resetPasswordService = (data) => {
  return api.call({
    type: ApiTypeEnum.Other,
    data: { ...data },
    query: PASSWORDRESETMUTATION,
    action: QueryAction.PASSWORD_RESET,
  });
};

